<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Active Listings</h4>
            </div>
            <div class="card-body">
              <b-overlay :show="isLoading" rounded="sm">
            <vue-good-table
            compactMode
            styleClass="vgt-table condensed"
            :columns="columns"
            :rows="groupedData"
            :row-style-class="rowStyleClassFn"
            :pagination-options="{
                enabled: true,
                perPage: 100
            }"
            :group-options="{
                enabled: true,
                collapsable: true,
                headerPosition: 'top'
            }"
            :search-options="{
                enabled: true,
                trigger: 'enter'
            }"
             :select-options="{
                enabled: true,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
            }">
        <template slot="table-header-row" slot-scope="props">
            <span class="my-fancy-class">
            {{ props.row.children[0].event.name }} <br/> </span>

            <span class="light-grey-text"> {{ props.row.children[0].event.date }}, {{ props.row.children[0].event.venue.name }}
            </span>
        </template>    
        
        </vue-good-table>
        </b-overlay>

 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  // import the styles
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';


  export default {
    // add to component
components: {
  VueGoodTable,
},
    data() {
      return {
        isLoading: false,
        listings: [],
        groupedData: [],
        columns: [
        { label: "ID", field: "id", hidden: true},
        { label: "Venue", field: "event.venue.name", hidden: true},
        { label: "City", field: "event.venue.city", hidden: true},
        { label: "State", field: "event.venue.state", hidden: true},
        { label: "Event", field:"event.name", hidden: true},
        { label: "Event Date", field: "event.date", hidden: true},
        { label: "Quantity", field: "quantity"},
        { label: "Section", field: "section" },
        { label: "Row", field: "row"},
        { label: "List Price", field: "listPrice" },
        { label: "Unit Cost Avg", field:"unitCostAverage"},
        { label: "Tags", field: "tags"},
        { label: "Stock Type", field: "stockType" },
        { label: "Broadcasting", field: "broadcast" },
      ],
      rows: [
        { id: 1, name: "John Doe", age: 28 },
        { id: 2, name: "Jane Smith", age: 34 },
        { id: 3, name: "Sam Johnson", age: 22 },
        { id: 4, name: "Chris Lee", age: 29 },
      ],
        expandedIndex: null,
        expanded: false,
        fields: [
          {key: 'id', label: 'ID'},
          { key: 'event.venue.city', label: 'City' },
          { key: 'event.venue.state', label: 'State' },
          { key: 'event.venue.name', label: 'Venue' },
          { key: 'event.date', label: 'Date' },
          { key: 'event.name', label: 'Event' },
          { key: 'section', label: 'Section' },
          { key: 'cost', label: 'Price' },
          { key: 'quantity', label: 'Quantity' },
          { key: 'details', label: 'Details' }
        ]
      };
    },
    methods: {
        rowStyleClassFn(row) {
            
            if (row.mode === 'span') {
              // Check if ANY record in children array has broadcast set to false
                return row.children.some((child) => !child.broadcast) ? 'header-no-broadcast' : '';
                
            } else {
                return !row.broadcast ? 'red-background' : '';
            }

            
    },
      async fetchListings() {
        this.isLoading = true;
        try {
            const currentDate = new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" });

            // const today = new Date().toLocaleDateString("en-US", { timeZone: "America/New_York" });
            // const currentDate = today.toISOString().split('T')[0]; // Outputs: "2025-02-10"
            // const current = new Date().toLocaleDateString("en-US", { timeZone: "America/New_York" });

            console.log(currentDate);
          const response = await fetch(
            "https://skybox.vividseats.com/services/inventory?ticketStatus=AVAILABLE&eventDateFrom=" + currentDate,
            {
              headers: {
                "accept": "application/json",
                "X-Application-Token": "ff42e57f-1171-4ff9-a452-aa7ae5f9fdde",
                "X-Api-Token": "984730ee-a2e3-4f8b-9726-34f2b2ff0598",
              },
            }
          );
          
          const data = await response.json();
          this.listings = data['rows'];
        //   console.log(this.listings);
          this.processGroupData(data);
          this.isLoading = false;

        } catch (error) {
            this.isLoading = false;
          console.error("Error fetching listings:", error);
        }
      },
     
     processGroupData(data) {
  try {
    // Validate input
    if (!data.rows || !Array.isArray(data.rows)) {
      throw new Error("Invalid JSON format. Expected 'rows' array.");
    }

    const groupedData = {};

    // Group data by "event name + date + venue name"
    data.rows.forEach((row) => {
      const event = row.event;
      const eventName = event.name;
      const venueName = event.venue.name;
      const eventDate = event.date;
      const groupKey = `${eventName} - ${eventDate} - ${venueName}`;

      // Initialize group if it doesn't exist
      if (!groupedData[groupKey]) {
        groupedData[groupKey] = {
          mode: "span",
          label: groupKey,
          html: true,
          eventDate: new Date(eventDate), // Convert to Date for sorting
          children: [],
        };
      }

      // Add row to the corresponding group
      groupedData[groupKey].children.push(row);
    });

    // Convert grouped object into array format & sort by event date
    const formattedData = Object.values(groupedData)
      .sort((a, b) => a.eventDate - b.eventDate) // Sort by eventDate
    //   .map(({ eventDate, ...rest }) => rest); // Remove eventDate before returning
    this.groupedData=formattedData;
  } catch (error) {
    throw new Error(`Error processing group data: ${error.message}`);
  }
},
      toggleDetails(index) {
        this.expandedIndex = this.expandedIndex === index ? null : index;
        this.expanded = this.expandedIndex !== null;
      },

      
    },
    mounted() {
      this.fetchListings();
    },
  };
  </script>
  
  <style >
  b-button {
    cursor: pointer;
  }
  .light-grey-text {
    color: #656464; /* Light Grey */
    font-size: 12px;
    padding-left: 35px;
}
/* Apply red background to rows that contain at least one child with broadcast: false */
.red-background {
  background-color:#f7c5c5;
  color: #000000;
}

.header-no-broadcast {
  color: #fc6969;
}
  </style>
  